// extracted by mini-css-extract-plugin
export default {"product__list":"ProductListMain_product__list__P+8sF","product__navigation":"ProductListMain_product__navigation__xlqJn","product__title":"ProductListMain_product__title__giQmN"};